import { DetailDeleteHeaderAction } from '@/features/shared/components/DetailDeleteHeaderAction';
import { EntityTagsMetadataSection } from '@/features/shared/components/EntityTagsMetadataSection';
import { DetailPageTemplate, DetailTitlePrefix } from '@/ui/composites/scaffolds';
import { Text } from '@/ui/primitives/Text';
import type { ReactElement } from 'react';

type FeatureDetailContentProps = {
  title: string;
  tags: string[] | undefined;
  onDelete?: () => Promise<void> | void;
  deleteLoading?: boolean;
};

export const FeatureDetailContent = ({
  title,
  tags,
  onDelete,
  deleteLoading = false,
}: FeatureDetailContentProps): ReactElement => (
  <DetailPageTemplate
    title={
      <Text role="sectionTitle" component="h1">
        <DetailTitlePrefix label="Feature" />
        {title}
      </Text>
    }
    headerActions={
      <DetailDeleteHeaderAction
        onDelete={onDelete}
        deleteLoading={deleteLoading}
        dialogTitle="Delete Feature"
        dialogDescription="This will permanently delete the feature. This action cannot be undone."
        confirmLabel="Delete Feature"
      />
    }
    metadata={<EntityTagsMetadataSection tags={tags} />}
  />
);
